import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../lib/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import SupportUI from './SupportUI';

const SupportWidget: React.FC = () => {
    const { currentUser: user } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const [hasUnread, setHasUnread] = useState(false);

    // Minimal listener for the badge
    React.useEffect(() => {
        if (!user) return;

        const q = query(
            collection(db, 'support_tickets'),
            where('userId', '==', user.id)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const unread = snapshot.docs.some(doc => doc.data().unreadUser);
            setHasUnread(unread);
        });

        return () => unsubscribe();
    }, [user]);

    if (!user) return null;

    return (
        <>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: 20, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 20, scale: 0.95 }}
                        className="fixed bottom-24 right-6 w-96 max-h-[600px] bg-white rounded-3xl shadow-2xl border border-gray-100 z-[9000] overflow-hidden flex flex-col hidden md:flex"
                    >
                        <SupportUI mode="widget" onClose={() => setIsOpen(false)} />
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Floating Button */}
            <motion.button
                onClick={() => setIsOpen(!isOpen)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.9 }}
                className="fixed bottom-6 right-6 w-14 h-14 bg-[#1d1d1f] text-white rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.12)] items-center justify-center z-[9000] hover:shadow-[0_8px_30px_rgb(0,0,0,0.2)] transition-shadow hidden md:flex"
            >
                {isOpen ? (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                ) : (
                    <div className="relative">
                        <span className="text-2xl">🎧</span>
                        {hasUnread && (
                            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-[#1d1d1f]"></span>
                        )}
                    </div>
                )}
            </motion.button>
        </>
    );
};

export default SupportWidget;
